module.exports = __webpack_public_path__ + "img/zhendong3.gif";